import { UI_Accordion } from 'ui/components/3-organisms/Accordion/Accordion';
import { GLOBAL_THEME_DEFAULT } from '_constants';

// Contexts
import { useSiteContext } from 'application/contexts/SiteContext';

export const AccordionFeature: React.FC<Content.Accordion> = ({ content }) => {
	const { items } = content?.properties ?? {};
	const SiteContext = useSiteContext();
	const globalTheme: string = SiteContext.settings.globalTheme?.setTheme ?? GLOBAL_THEME_DEFAULT;

	return (
		<UI_Accordion
			title={content?.properties.heading}
			items={items?.map(
				({
					content: {
						properties: { heading, text },
					},
				}) => ({
					heading,
					text,
					globalTheme,
				}),
			)}
			description={content?.properties?.description}
			kicker={{
				firstWord: content?.properties?.kickerFirstWord,
				secondWord: content?.properties?.kickerSecondWord,
			}}
			bgColor={content?.properties?.color}
		/>
	);
};
